import { H4, H5 } from 'AbstractElements';
import { Col, Card, Table, Modal, ModalBody, ModalHeader } from 'reactstrap';
import React, { Fragment, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PaginationComponent from 'Component/Common/PaginationComponent';
import { setFilters, setFormData } from 'Services/Features/Admin/adminSlice';
import {
    handleNextPagination,
    handleBackPagination,
    handleClickPagination
} from 'Component/DashboardQeza/Common/PaginationUtils';
import { handleDelete } from 'Component/DashboardQeza/Common/DeleteUtils';
import { deleteAdmin } from 'Services/Features/Admin/Utils/adminUtils';
import { useNavigate } from 'react-router';
 
const TreatmentTable = ({ setRefetch }) => {
    const admins = useSelector((state) => state.admin.admins);
    const loading = useSelector((state) => state.admin.loading);
    const pagination = useSelector((state) => state.admin.pagination);
    const filters = useSelector(state => state.user.filters);
    const dispatch = useDispatch();
    const history = useNavigate();

    const handleEdit = (item) => {
        console.log(item, 'item');
        dispatch(setFormData(item));

        history(`${process.env.PUBLIC_URL}/admin/edit/${item.id}`);
    };
    return (
        <Fragment>
            <Col sm="12" lg="12" xl="12">
                <Card>
                <div className="mb-5">
                    <Col sm="12" lg="12" xl="12">
                        <div className="table-responsive">
                        <Table className=" table-hover table-border-vertical">
                            <thead className="bg-primary">
                            <tr>
                                <th scope="col" className="sticky-col-number" style={{ width: '15px' }}>{'#'}</th>
                                <th scope="col" className="" style={{ whiteSpace: 'nowrap', overflow: 'hidden' }}>{'Nama'}</th>
                                <th scope="col">{'Email'}</th>
                                <th scope="col" className="text-center">{'Role'}</th>
                                <th scope="col" className="text-center">{'Poin'}</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                admins && admins.map((item, i) => 
                                <tr key={item.id}>
                                    <th className="sticky-col-number" scope="row" style={{ verticalAlign: "top" }}>{i + 1}</th>
                                    <td className="">
                                        <H5>{item.name}</H5>
                                    </td>
                                    <td><H5>{item.email}</H5><code>{item.phone}</code></td>
                                    <td className="text-center">
                                        <H5>{item.is_super_admin ? 'Super Admin' : item.is_admin ? `Admin ${item.branch_name}` : item.is_cs ? `Customer Service ${item.branch_name}` : ''}</H5>
                                    </td>
                                    <td>
                                        <div className="d-flex justify-content-center align-items-center">
                                            <button
                                                title="Edit"
                                                className="btn btn-primary"
                                                style={{ padding: '4px 8px', fontSize: '12px' }}
                                                onClick={() => handleEdit(item)}
                                            >
                                                <i className="fa fa-pencil"></i>
                                            </button>
            
                                            <button
                                                title="Hapus"
                                                className="btn btn-danger ms-2"
                                                style={{ padding: '4px 8px', fontSize: '12px' }}
                                                    onClick={() => handleDelete(dispatch, item.id, setRefetch, deleteAdmin)}
                                            >
                                                <i className="fa fa-trash"></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                                )
                            }
                            </tbody>
                        </Table>
                        </div>
                    <div style={{ marginTop: '100px', display: 'flex', justifyContent: 'center' }}>
                        {loading === false && admins && admins.length > 0 && (
                        <PaginationComponent
                            pagination={pagination}
                            handleBackPagination={() => handleBackPagination(pagination, filters, dispatch, setFilters, setRefetch)}
                            handleClickPagination={(page) => handleClickPagination(page, filters, dispatch, setFilters, setRefetch)}
                            handleNextPagination={() => handleNextPagination(pagination, filters, dispatch, setFilters, setRefetch)}
                        />
                        )}
                    </div>
                    </Col>
                </div>
                </Card>
            </Col>
        </Fragment>
    );
    };

export default TreatmentTable;